<template lang="pug">
#speakers-tab
  spinner(v-if="settings.loading")
  div(v-else)
    b-table(
      sort-icon="chevron-up"
      :data="speakers"
      :default-sort="[filters.sort.field, filters.sort.order]"
      :default-sort-direction="filters.sort.order"
      :total="pagination.total"
      :current-page="pagination.page"
      :per-page="pagination.per"
      @click="open"
      @page-change="getPage"
      @sort="sort"
      backend-pagination
      backend-sorting
      hoverable
      paginated
    )
      template(slot-scope="props")
        b-table-column(
          label="Name"
          field="full_name.raw"
          sortable
        ) {{ props.row.full_name }}
        b-table-column(
          label="Episodes"
          field="episode_count"
          sortable
        )
          small {{ props.row.episode_count }}
        b-table-column(
          label="Category"
          field="category"
          sortable
        )
          small {{ props.row.category | capitalize }}
        b-table-column(label="Page")
          small
            a.has-text-primary(:href="`https://${account.host}/speakers/${props.row.id}`" target="_blank")
              span View
              b-icon(icon="open-in-new" size="is-small")
</template>

<script>
import { mapGetters } from 'vuex';
import SpeakerForm from '@/components/form/SpeakerForm';
import Spinner from '@/components/Spinner';
import * as actions from '@/store/types/actions';
import * as getters from '@/store/types/getters';
import * as mutations from '@/store/types/mutations';

export default {
  name: 'speakers-tab',
  components: {
    SpeakerForm,
    Spinner,
  },
  computed: {
    ...mapGetters({
      account: getters.GET_ACCOUNT,
      filters: getters.GET_SPEAKER_FILTERS,
      mediaRefresh: getters.GET_MEDIA_REFRESH,
      mediaTab: getters.GET_MEDIA_TAB,
      mediaTags: getters.GET_MEDIA_TAGS,
      speakers: getters.GET_SPEAKERS,
    }),
    pageQuery() {
      const from = this.pagination.per * (this.pagination.page - 1);
      const sort = {};
      sort[this.filters.sort.field] = this.filters.sort.order;
      const payload = {
        from,
        size: this.pagination.per,
        sort: [sort],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
            ],
          },
        },
      };
      this.mediaTags.forEach((tag) => {
        const item = {};
        switch (tag._index) {
          case 'doxa_episodes':
            // item.match = { id: tag._id };
            break;
          case 'doxa_channels':
            // item.match = { id: tag._id };
            break;
          case 'doxa_episode_collections':
            // item.match = { id: tag._id };
            break;
          case 'doxa_speakers':
            item.match = { id: tag._id };
            // item.match = { '_embedded.speaker.id': tag._id };
            break;
          default:
        }
        if (Object.entries(item).length > 0) {
          payload.query.bool.must.push(item);
        }
      });
      return payload;
    },
  },
  created() {
    this.getPage(1);
  },
  data() {
    return {
      pagination: {
        page: 1,
        per: 26,
        total: 0,
      },
      settings: {
        loading: false,
      },
    };
  },
  methods: {
    async getPage(page, skipAnimation) {
      if (!skipAnimation) this.settings.loading = true;
      this.pagination.page = page;
      const response = await this.$store.dispatch(actions.DO_SEARCH_SPEAKERS, this.pageQuery);
      this.pagination.total = response.hits.total;
      if (!skipAnimation) this.settings.loading = false;
    },
    async open(speaker) {
      await this.$store.dispatch(actions.DO_GET_SPEAKER, {
        id: speaker.id,
        zoom: 'header_image,profile_image',
      });
      this.$buefy.modal.open({
        parent: this,
        component: SpeakerForm,
        hasModalCard: true,
      });
    },
    async refresh() {
      const response = await this.$store.dispatch(actions.DO_SEARCH_SPEAKERS, this.pageQuery);
      this.$store.commit(mutations.SET_MEDIA_REFRESH, false);
      this.pagination.total = response.hits.total;
    },
    sort(field, order) {
      this.$store.commit(mutations.SET_SPEAKER_FILTER_FIELD, {
        key: 'sort.field',
        val: field,
      });
      this.$store.commit(mutations.SET_SPEAKER_FILTER_FIELD, {
        key: 'sort.order',
        val: order,
      });
      this.getPage(1, true);
    },
  },
  watch: {
    mediaRefresh(val) {
      if (val) this.refresh();
    },
  },
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/SpeakersTab.vue